import React, { Component } from 'react';
import './css/App.css';
import './css/font-awesome.min.css';
import ProductDesigner from './ProductDesigner.js';


class App extends Component {
    render() {

        return (
            <ProductDesigner 
                designerRenderMode={this.props.designerInitConfig.renderMode}
                designerInitConfig={this.props.designerInitConfig}
                designerExportScaling={this.props.designerInitConfig.exportScaling}
                designerExportPerspective={this.props.designerInitConfig.exportPerspective}
                designerExportBorder={this.props.designerInitConfig.exportBorder}
                designerSubmitMode={this.props.designerInitConfig.submitMode}
                designerDebug={this.props.designerInitConfig.showDebug}
                designerLoadedCallback={this.props.designerInitConfig.designerLoadedCallback}
                designerConfigInterfaceUrl={this.props.designerInitConfig.designerConfigInterfaceUrl}
                designerSelectedSize={this.props.designerInitConfig.designerSelectedSize}
                designerSelectedColor={this.props.designerInitConfig.designerSelectedColor}
                isDesignerAddonMode={this.props.designerInitConfig.isDesignerAddonMode}
                addonArticleName={this.props.designerInitConfig.addonArticleName}
                addonBasketArticleId={this.props.designerInitConfig.addonBasketArticleId}
            />
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js